@if (isEmbedded || content) {
  <main class="d-flex" [class.embedded]="isEmbedded">
    <section
      class="jumbotron text-center"
      [class.col-6]="!isEmbedded"
      [class.my-5]="!isEmbedded">
      <router-outlet></router-outlet>
    </section>
  </main>
}
